import Select, { components } from 'react-select';
import { ReactSelectOptionProp } from '../interface/interface';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { DownCaretIcon } from '../assets/svgImages';
import { genders, title } from '../constant/constant';
import CustomDatePicker from '../components/CustomDatePicker';
import PasswordChecklist from 'react-password-checklist';
import instance from '../config/axios';
import passwordValidator from 'password-validator';
import { patientRegisterValidator } from '../validator/patientRegistorValidator';
import showToast from '../components/ToastComponent';
import { AddressAutocomplete } from '../components/AddressAutocomplete';
import { validateEmail } from '../utils/validateEmail';
import moment from 'moment';
import isValidAustralianPostcode from 'is-valid-australian-postcode';
import { getShippingAddress } from '../utils/formatAddress';

const RegisterPatient = () => {
  const postal = useRef<HTMLInputElement | null>(null);
  const [data, setData] = useState({
    title: '',
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    dob: undefined,
    mobile: '',
    gender: '',
    contactName: '',
    contactPhone: '',
    contactRelationship: '',
  });
  const validPassword = new passwordValidator();
  const [concent, setConcent] = useState<boolean>(false);
  const [emergencyConsent, setEmergencyConsent] = useState<boolean>(false);

  const [selectTitle, setSelectTitle] = useState<null | {
    label: string;
    value: string;
  }>(null);

  const [gender, setGender] = useState<ReactSelectOptionProp>();
  const [error, setError] = useState<boolean>(false);
  const [show, setShow] = useState(false);
  const [shippingAddress1, setShippingAddress1] = useState<string>('');
  const [shippingAddress2, setShippingAddress2] = useState<string>('');
  const [shippingCity, setShippingCity] = useState<string>('');
  const [shippingProvince, setShippingProvince] = useState<string>('');
  const [shippingZip, setShippingZip] = useState<string>('');
  const [shippingCountry, setShippingCountry] = useState<string>('Australia');

  useEffect(() => {
    if (postal.current) {
      postal.current.addEventListener('wheel', (e) => e.preventDefault());
    }
  }, []);

  const validatedPassword = () => {
    validPassword
      .is()
      .min(8)
      .has()
      .uppercase()
      .has()
      .not()
      .spaces()
      .has()
      .symbols()
      .has()
      .digits(1);

    if (validPassword.validate(data.password) && concent) return true;

    return false;
  };

  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleDate = (date: Date, key: string) => {
    setData({
      ...data,
      [key]: new Date(date),
    });
  };

  const clearInput = () => {
    setData({
      title: '',
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      dob: undefined,
      mobile: '',
      gender: '',
      contactName: '',
      contactPhone: '',
      contactRelationship: '',
    });
    setGender(undefined);
    setSelectTitle(null);
    setConcent(false);
    setEmergencyConsent(false);
  };

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    try {
      e.preventDefault();

      const validateZipCode = isValidAustralianPostcode(shippingZip);
      if (!validateZipCode) {
        showToast({
          message: 'Please Enter Valid Postcode',
          type: 'warning',
        });
        return;
      }

      const frameData = {
        userData: {
          title: data.title,
          firstName: data.firstName,
          lastName: data.lastName,
          gender: data.gender,
          dob: data.dob
            ? moment(data.dob).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
            : '-',
          mobile: data.mobile,
          email: data.email,
          password: data.password,
        },

        address: {
          address_line_one: shippingAddress1,
          address_line_two: shippingAddress2,
          city: shippingCity,
          state: shippingProvince,
          post_code: shippingZip,
          street_number: '',
          street_name: '',
        },

        emergency_contact_information: {
          contact_name: data.contactName,
          contact_number: data.contactPhone,
          contact_relationship: data.contactRelationship,
          consent: emergencyConsent,
        },
      };

      const patientRegisterVaidate = patientRegisterValidator(frameData);

      if (patientRegisterVaidate) {
        console.log(patientRegisterVaidate);
        setError(true);
        return;
      }

      const response = await instance.post(
        '/api/v1/patient/register',
        frameData,
        {
          headers: {},
        },
      );

      if (response.status === 201) {
        showToast({
          message: 'Patient Register Successfully',
          type: 'success',
        });
        clearInput();
        setError(false);
      } else {
        showToast({
          message: response.data.message,
          type: 'info',
        });
      }
    } catch (err) {
      console.log(err);
      showToast({
        message: 'Error at Register Patient',
        type: 'error',
      });
    }
  };

  const DropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props}>
        <DownCaretIcon />
      </components.DropdownIndicator>
    );
  };
  return (
    <>
      <div className="px-4 sm:px-0">
        <h2 className="text-4xl font-bold text-primary-blue-500">
          Welcome to Monivea Road
        </h2>
        <h2 className="mb-5 text-2xl font-regular text-primary-blue-500">
          Please complete the registration form to create your account.
        </h2>
      </div>

      <div className="p-7 bg-secondary-pink-50 shadow rounded-xl mb-10">
        <h3 className="mb-3 text-xl font-semibold text-primary-blue-500 ml-10">
          Create Account
        </h3>

        {/* Personal Information */}
        <div className="bg-white rounded px-10 py-8 rounded-md">
          <h3 className="mb-3 text-xl font-semibold text-primary-blue-500">
            Personal Information
          </h3>
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
            <div className="sm:col-span-1">
              <label className="text-lg font-semibold text-secondary-pink-700">
                Title
              </label>
              <div className="">
                <Select
                  value={selectTitle}
                  options={title as ReactSelectOptionProp[]}
                  onChange={(selectedOption) => {
                    setSelectTitle(selectedOption);
                    setData({
                      ...data,
                      title: selectedOption!.value,
                    });
                  }}
                  isSearchable={false}
                  components={{
                    DropdownIndicator,
                    IndicatorSeparator: () => null,
                  }}
                />
              </div>
            </div>
            <div className="sm:col-span-2">
              <label
                htmlFor="first-name"
                className="text-lg font-semibold text-secondary-pink-700"
              >
                First name <span className="text-red-500">*</span>
              </label>
              <div className="">
                <input
                  type="text"
                  name="firstName"
                  id="first-name"
                  autoComplete="given-name"
                  className={`text-sm font-regular border  
                        rounded-md p-2 w-full 
                        ${
                          error && !data.firstName
                            ? 'border-red-400'
                            : 'border-secondary-cornflowerblue-400'
                        }`}
                  value={data.firstName}
                  onChange={(e) => handleInput(e)}
                />
              </div>
              {error && !data.firstName && (
                <small className="text-red-600">First Name is required</small>
              )}
            </div>
            <div className="sm:col-span-2">
              <label
                htmlFor="last-name"
                className="text-lg font-semibold  text-secondary-pink-700"
              >
                Last name <span className="text-red-500">*</span>
              </label>
              <div className="">
                <input
                  type="text"
                  name="lastName"
                  id="last-name"
                  autoComplete="family-name"
                  className={`text-sm font-regular border rounded-md p-2 w-full ${
                    error && !data.lastName
                      ? 'border-red-400'
                      : 'border-secondary-cornflowerblue-400'
                  }`}
                  value={data.lastName}
                  onChange={(e) => handleInput(e)}
                />
              </div>
              {error && !data.lastName && (
                <small className="text-red-600">Last Name is required</small>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-8 mt-5 lg:grid-cols-6">
            <div className="sm:col-span-2">
              <label className="text-lg font-semibold  text-secondary-pink-700">
                Gender <span className="text-red-500">*</span>
              </label>
              <div className="">
                <Select
                  value={gender}
                  options={genders as ReactSelectOptionProp[]}
                  onChange={(selectedOption) => {
                    setGender(selectedOption as ReactSelectOptionProp);
                    setData({
                      ...data,
                      gender: selectedOption!.value,
                    });
                  }}
                  isSearchable={false}
                  components={{
                    DropdownIndicator,
                    IndicatorSeparator: () => null,
                  }}
                  className={error && !data.gender ? 'select-error' : ''}
                />
              </div>
              {error && !data.gender && (
                <small className="text-red-600">Gender is required</small>
              )}
            </div>
            <div className="sm:col-span-2">
              <label className="text-lg font-semibold  text-secondary-pink-700">
                Date Of Birth <span className="text-red-500">*</span>
              </label>
              <div className="">
                <div className="relative custom-date-picker">
                  <CustomDatePicker
                    value={data.dob}
                    handleDate={(date: Date) => handleDate(date, 'dob')}
                    className={error && !data.dob ? 'dob-error' : ''}
                    maxDate
                  />
                </div>
              </div>
              {error && !data.dob && (
                <small className="text-red-600">DOB is required</small>
              )}
            </div>

            <div className="sm:col-span-2">
              <label
                htmlFor="mobile"
                className="text-lg font-semibold  text-secondary-pink-700"
              >
                Primary Contact <span className="text-red-500">*</span>
              </label>
              <div className=" flex rounded-md shadow-sm">
                <span
                  className={`inline-flex items-center rounded-l-md border border-r-0 
                       px-3 text-gray-500 text-sm ${
                         (error && !data.mobile) ||
                         (error && data.mobile.split('').length < 9) ||
                         (error && data.mobile.split('').length > 9)
                           ? 'border-red-400'
                           : 'border-secondary-cornflowerblue-400'
                       }`}
                >
                  +61
                </span>
                <input
                  type="number"
                  name="mobile"
                  id="mobile"
                  className={`rounded-none rounded-r-md placeholder:text-gray-400 text-sm 
                        font-regular border p-2 w-full rounded-md ${
                          (error && !data.mobile) ||
                          (error && data.mobile.split('').length < 9) ||
                          (error && data.mobile.split('').length > 9)
                            ? 'border-red-400'
                            : 'border-secondary-cornflowerblue-400'
                        }`}
                  placeholder="123456789"
                  onChange={(e) => handleInput(e)}
                  value={data.mobile}
                />
              </div>
              {error && !data.mobile ? (
                <small className="text-red-600">
                  Contact number is required
                </small>
              ) : error && data.mobile.split('').length < 9 ? (
                <small className="text-red-600">
                  Please enter valid contact number
                </small>
              ) : error && data.mobile && data.mobile.split('').length > 9 ? (
                <small className="text-red-600">
                  Please enter valid contact number
                </small>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>

        {/* Address */}
        <div className="bg-white rounded px-10 py-8 rounded-md mt-10">
          <h3 className="mb-3 text-xl font-semibold text-primary-blue-500">
            Address Information{' '}
            <small className="text-sm font-regular">(optional)</small>
          </h3>

          <div className="grid grid-cols-1 gap-8 mt-5 register_patient">
            <AddressAutocomplete
              addressRefValue={shippingAddress1}
              address1ManualSetter={(address1) => setShippingAddress1(address1)}
              state={{
                city: shippingCity,
                country: shippingCountry,
                zip: shippingZip,
                state: shippingProvince,
                address2: shippingAddress2 ?? '',
                streetNumber: '',
                streetName: '',
                unit: '',
              }}
              setter={(data) => {
                setShippingCity(data.city);
                setShippingCountry(data.country);
                setShippingZip(data.zip);
                setShippingProvince(data.state);
                setShippingAddress2(data.address2 ?? '');
                if (process.env.VITE_MAPS_AUTOCOMPLETE_KEY)
                  setShippingAddress1(
                    data?.streetName
                      ? getShippingAddress(data)
                      : shippingAddress1,
                  );
              }}
              freezeAddressFields={false}
            />
          </div>
        </div>

        {/* Emergency Contact Information */}
        <div className="bg-white rounded px-10 py-8 rounded-md mt-10">
          <h3 className="mb-3 text-xl font-semibold text-primary-blue-500">
            Emergency Contact Information{' '}
            <small className="text-sm font-regular">(optional)</small>
          </h3>
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3 mt-5">
            <div className="sm:col-span-1">
              <label
                htmlFor="contact-name"
                className="text-lg font-semibold  text-secondary-pink-700"
              >
                Emergency Contact Name
              </label>
              <div className="">
                <input
                  type="text"
                  name="contactName"
                  id="contact-name"
                  autoComplete="given-name"
                  className={`text-sm font-regular border  
                        rounded-md p-2 w-full  border-secondary-cornflowerblue-400
                        `}
                  value={data.contactName}
                  onChange={(e) => handleInput(e)}
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="contact-phone"
                className="text-lg font-semibold text-secondary-pink-700"
              >
                Contact Phone
              </label>
              <div className=" flex rounded-md shadow-sm">
                <span
                  className="inline-flex items-center rounded-l-md border border-r-0 
                      border-secondary-cornflowerblue-400 px-3 text-gray-500 text-sm"
                >
                  +61
                </span>
                <input
                  type="number"
                  name="contactPhone"
                  id="conatact-phone"
                  className="rounded-none rounded-r-md placeholder:text-gray-400 text-sm 
                        font-regular border border-secondary-cornflowerblue-400 p-2 w-full rounded-md"
                  placeholder="123456789"
                  onChange={(e) => handleInput(e)}
                  value={data.contactPhone}
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="contact-relationship"
                className="text-lg font-semibold text-secondary-pink-700"
              >
                Relationship to Patient
              </label>
              <div className="">
                <input
                  type="text"
                  name="contactRelationship"
                  id="contact-relationship"
                  autoComplete="given-name"
                  className={`text-sm font-regular border  
                        rounded-md p-2 w-full  border-secondary-cornflowerblue-400
                        `}
                  value={data.contactRelationship}
                  onChange={(e) => handleInput(e)}
                />
              </div>
            </div>
          </div>
          <div className="flex items-end">
            <input
              id="comments"
              aria-describedby="comments-description"
              name="comments"
              type="checkbox"
              className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600 mt-5"
              checked={emergencyConsent}
              onChange={() => setEmergencyConsent(!emergencyConsent)}
            />
            <small className="ml-3 text-1xl text-primary-blue-500">
              I give consent for my emergency contact to speak on my behalf
            </small>
          </div>
        </div>

        {/* Email and password */}
        <div className="bg-white rounded px-10 py-8 mt-10 rounded-md">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            <div className="sm:col-span-2">
              <label
                htmlFor="email"
                className="text-sm font-semibold  text-secondary-pink-700"
              >
                Email address <span className="text-red-500">*</span>
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  className={`text-sm font-regular border 
                        rounded-md p-2 w-full 
                        ${error && !data.email && !validateEmail(data.email) ? 'border-red-400' : 'border-secondary-cornflowerblue-400'}`}
                  onChange={(e) => handleInput(e)}
                  value={data.email}
                />
              </div>
              {error && !data.email ? (
                <small className="text-red-600">Email is required</small>
              ) : error && !validateEmail(data.email) ? (
                <small className="text-red-600">Email Not in valid form</small>
              ) : (
                ''
              )}
            </div>

            <div className="sm:col-span-2">
              <label
                htmlFor="password"
                className="text-sm font-semibold  text-secondary-pink-700"
              >
                Password <span className="text-red-500">*</span>
              </label>
              <div className="mt-2">
                <div className="relative">
                  <input
                    id="password"
                    name="password"
                    type={show ? 'text' : 'password'}
                    autoComplete="email"
                    className="text-sm font-regular border border-secondary-cornflowerblue-400 rounded-md p-2 w-full"
                    onChange={(e) => handleInput(e)}
                    value={data.password}
                  />
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                    {show ? (
                      <span onClick={() => setShow(!show)}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="w-6 h-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 
                          0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                        </svg>
                      </span>
                    ) : (
                      <span onClick={() => setShow(!show)}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="w-6 h-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 
                          12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 
                          4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 
                          6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                          />
                        </svg>
                      </span>
                    )}
                  </div>
                </div>
              </div>
              {data.password && (
                <div className="mt-4 password-checklist">
                  <PasswordChecklist
                    rules={['minLength', 'specialChar', 'number', 'capital']}
                    minLength={8}
                    value={data.password}
                    specialCharsRegex={
                      /^(?=.*[!@#$%^&*()\-=_+[\]{};':"\\|,.<>?])(?!.*(1234|aaaa|abcd)).*$/g
                    }
                    messages={{
                      specialChar:
                        'Password should contain special character and does not contain any sequences',
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Consent from patient */}
        <div className=" mt-5 mx-auto" style={{ width: '90%' }}>
          <div className="relative flex items-start">
            <div className="flex h-6 items-center">
              <input
                id="comments"
                aria-describedby="comments-description"
                name="comments"
                type="checkbox"
                className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                checked={concent}
                onChange={() => setConcent(!concent)}
              />
            </div>
            <div className="ml-3 text-sm leading-6">
              <label htmlFor="comments" className="font-medium text-gray-900">
                I confirm that I've read, understand, and agree to the{' '}
                <a
                  href="https://monivearoad.com.au/patient-privacy-policy/"
                  className="text-indigo-600"
                >
                  Privacy Statment
                </a>{' '}
                and{' '}
                <a
                  href="https://monivearoad.com.au/terms-of-service/"
                  className="text-indigo-600"
                >
                  Terms and Conditions
                </a>
                . By checking this box, I consent to the collection, processing,
                and storage of my personal information. For more details, refer
                to our{' '}
                <a
                  href="https://monivearoad.com.au/faqs/"
                  className="text-indigo-600"
                >
                  FAQ
                </a>{' '}
                section
              </label>
            </div>
          </div>
        </div>

        {/* Form submission */}
        <div className="flex items-center justify-center gap-x-6 py-8">
          <button
            type="button"
            className="text-secondary-pink-700 font-semibold w-24 px-4 py-2 "
            onClick={() => {
              clearInput();
              window.location.replace('/');
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className={`${!validatedPassword() && 'opacity-50'} 
                bg-primary-blue-500 border border-solid border-primary-blue-500 text-white px-4 py-2 w-64 rounded`}
            onClick={handleSubmit}
            disabled={!validatedPassword()}
          >
            Register
          </button>
        </div>
      </div>
    </>
  );
};

export default RegisterPatient;
